import { render } from "./MmodelsUpdate.vue?vue&type=template&id=4f638c28&scoped=true"
import script from "./MmodelsUpdate.vue?vue&type=script&lang=js"
export * from "./MmodelsUpdate.vue?vue&type=script&lang=js"

import "./MmodelsUpdate.vue?vue&type=style&index=0&id=4f638c28&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f638c28"]])

export default __exports__